import React from 'react';

export const IconDoubleCheck = ({style}) => {

    return (<svg className="icon-double-check" style={style || {}} width="16" height="16" viewBox="0 0 16 16" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M10.782 4.721a.75.75 0 010 1.06l-6 6a.75.75 0 01-1.06 0l-2.502-2.5A.75.75 0 012.28 8.22l1.971 1.97 5.47-5.469a.75.75 0 011.06 0zM15.03 4.721a.75.75 0 010 1.06l-6 6a.75.75 0 11-1.06-1.06l6-6a.75.75 0 011.06 0z"
                  fill="currentColor"/>
        </svg>
    )
}